import { K8sProvider } from '@cast/shared-types';
import {
  AgentStatus,
  Cluster,
  ClusterDisplayStatus,
  ClusterRegion,
  ClusterStatus,
} from '@cast/types';
import {
  CloudAssetCluster,
  CloudAssetClusterProvider,
} from '@cast/types-inventory';

export const toCloudAssetProviderType = (
  providerType?: CloudAssetClusterProvider | null
): K8sProvider => {
  switch (providerType) {
    case CloudAssetClusterProvider.EKS:
      return K8sProvider.EKS;
    case CloudAssetClusterProvider.GKE:
      return K8sProvider.GKE;
    case CloudAssetClusterProvider.AKS:
      return K8sProvider.AKS;
    default:
      return K8sProvider.ANYWHERE;
  }
};

const toClusterRegion = (
  region: CloudAssetCluster['region']
): ClusterRegion => {
  if (region == null) {
    return { name: '', displayName: '' };
  }
  if (typeof region === 'string') {
    return { name: region, displayName: region };
  }
  return {
    name: region.name ?? '',
    displayName: region.displayName ?? region.name ?? '',
  };
};

/** Minimal Cluster for inventory-only assets (Classic merges these into the list count). */
export const toDiscoveredCluster = (
  asset: CloudAssetCluster
): Cluster | undefined => {
  if (!asset.id || !asset.name) {
    return undefined;
  }

  return {
    id: asset.id,
    name: asset.name,
    organizationId: asset.organizationId,
    providerNamespaceId: asset.providerNamespaceId,
    providerType: toCloudAssetProviderType(asset.providerType),
    region: toClusterRegion(asset.region),
    agentStatus: AgentStatus.DISCONNECTED,
    status: ClusterStatus.DISCOVERED,
    displayStatus: ClusterDisplayStatus.DISCOVERED,
  };
};
